import Vue from 'vue';

export const reportQQBrowser = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isStatistics = location.search.indexOf('statistics') > -1;
    const isQQBrowser = /qqbrowser|mqqbrowser|qq\//.test(ua);
    const isMobile = /mobile|android|iphone|ipad|phone/i.test(ua);
    const hash = '#/chat/wQrAwR';
    if (isQQBrowser && location.hash === hash && isStatistics) {
        if (Vue.$aegis) {
            const matches = ua.match(/(?:qqbrowser|mqqbrowser|qq)\/([\d.]+)/i);
            let version = '';
            if (matches) {
                version = matches[1];
            }
            Vue.$aegis.reportEvent({
                name: 'qqbrowser user',
                ext1: `${isMobile ? '移动端' : 'PC端'}`,
                ext2: `浏览器版本号：${version}`,
                ext3: `hash=${location.hash}&query=${location.search}`
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/reportEvent.js